import { css } from '@emotion/react';
import { Link, useLocation } from '@remix-run/react';
import { Box } from '@spark-web/box';
import { Hidden } from '@spark-web/hidden';
import { MenuIcon } from '@spark-web/icon';
import { useTheme } from '@spark-web/theme';
import { FC, useEffect, useState } from 'react';

import { User } from '~/types/user';

import logo from '../public/logo.svg';

import Navbar from './navbar';
import { UserProfile } from './user-profile';

export const HEADER_HEIGHT_PX = 90;

type HeaderProps = {
  user: Pick<User, 'name' | 'picture' | 'enterprisePartnerId'>;
};

export const Header: FC<HeaderProps> = ({ user }) => {
  const theme = useTheme();
  const [showNavbar, setShowNavbar] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // hides the navbar for mobile/tablet view when location changes
    if (showNavbar && location) {
      setShowNavbar(false);
    }
  }, [location]);

  return (
    <Box
      width="full"
      paddingY="large"
      as="header"
      borderBottom="standard"
      background="surface"
      display="flex"
      justifyContent="spaceBetween"
      css={css({
        position: 'fixed',
        top: 0,
        right: 0,
        width: '100%',
        height: HEADER_HEIGHT_PX,
        zIndex: `${theme.elevation.sticky}`,
        paddingRight: theme.spacing.medium,
        paddingLeft: theme.spacing.medium,
        [`@media (min-width: ${theme.breakpoint.desktop}px)`]: {
          paddingRight: theme.spacing.xlarge,
          paddingLeft: theme.spacing.xlarge,
        },
      })}
      data={{ testId: 'header' }}
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <Hidden above="tablet">
          <Box
            background={showNavbar ? 'surface' : 'primary'}
            padding="xsmall"
            borderRadius="small"
            onClick={() => setShowNavbar(!showNavbar)}
            border="primary"
            css={css({
              borderWidth: 2,
              marginRight: 3,
            })}
            data={{ testId: 'navbar-toggle' }}
          >
            <MenuIcon size="xsmall" tone={showNavbar ? 'primary' : 'neutral'} />
          </Box>
          {showNavbar && <Navbar styles={css({ width: '100%', marginTop: theme.spacing.xxlarge })} />}
        </Hidden>
        <Link to="/">
          <img
            src={logo}
            alt="Brighte logo"
            height="40"
            width="121"
            css={css({
              cursor: 'pointer',
              padding: theme.spacing.xsmall,
            })}
          />
        </Link>
      </Box>
      <UserProfile user={user} />
    </Box>
  );
};
export default Header;
